// Used for validating that a string is a properly formatted email address
const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9._+-]*[a-zA-Z0-9])?@[a-zA-Z0-9]([a-zA-Z0-9.-]*[a-zA-Z0-9])?(\.[a-zA-Z]{2,})+$/

/**
 * Validates that a string is a properly formatted email address.
 * Uses a regex pattern optimized to avoid catastrophic backtracking.
 * 
 * @param {string|null|undefined} input - The string to validate
 * @returns {boolean} True if input is a valid email format, false otherwise
 */
export const isValidEmail = (input) => {
  if (input == null || typeof input !== 'string') {
    return false
  }
  return EMAIL_VALIDATION_REGEX.test(input)
}

// Eaters validation constants
export const MAX_EATERS = 1000000
export const MIN_EATERS = 1

/**
 * Normalizes an eaters value for validation.
 * Handles null, undefined, empty strings, decimals, scientific notation, and non-numeric input.
 * 
 * @param {any} value - The value to normalize
 * @returns {number|null|'invalid'} Normalized integer value, null if empty, or 'invalid' if not a valid number
 */
export const normalizeEatersValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return null
  }
  const numValue = Number(value)
  if (isNaN(numValue) || !isFinite(numValue)) {
    return 'invalid'
  }
  return Math.round(numValue)
}

/**
 * Validates a normalized eaters value and returns an error message if invalid.
 * This function expects a normalized value (from normalizeEatersValue) to avoid duplicate normalization.
 * 
 * @param {number|null|'invalid'} normalizedValue - The normalized eaters value
 * @returns {string|null} Error message if invalid, null if valid
 */
export const validateEaters = (normalizedValue) => {
  if (normalizedValue === null) {
    return 'Please provide the number of eaters'
  }
  
  if (normalizedValue === 'invalid' || normalizedValue < MIN_EATERS) {
    return 'Please enter a valid number of guests (1-1,000,000)'
  }
  
  if (normalizedValue > MAX_EATERS) {
    return 'We can help with events of any size! For gatherings with more than 1,000,000 guests, please contact our sales team at concierge@roaminghunger.com or call us for personalized assistance.'
  }
  
  return null
}
